<template>
  <div class="container">
    <div class="container_form">
      <el-form
        :inline="true"
        :model="queryForm"
        ref="queryFormRefs"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
      >
        <el-form-item label="提成归属" prop="userIds">
          <el-select
            multiple
            filterable
            v-model="queryForm.userIds"
            placeholder="请选择提成归属账号"
            style="width: 200px"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getData">查询</el-button>
          <el-button type="info" size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="container_table">
        <div class="table_add">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            v-show="authorization('/home-admin/commission-rule/rule/add')"
            @click="editRule(false)"
          >
            新增
          </el-button>
        </div>
        <BaseTable
          :tableData="tableData"
          :columns="columns"
          :showPagination="true"
          :showOperationColumn="true"
          :operationColumnWidth="200"
          operationColumnFixed="right"
          :total="total"
          :page-size="page.pageSize"
          :current-page="page.pageNum"
          :pageSizes="sizes"
          @size-change="sizeChange"
          @current-change="handleCurrentChange"
          v-loading="loading"
          stripe
        >
          <template #isGlobal="{ row }">
            <span v-if="row.isGlobal === 1">是</span>
            <span v-else>否</span>
          </template>
          <template #commissionRate="{ row }">
            <span>{{ row.commissionRate }}%</span>
          </template>
          <template #tierCount="{ row }">
            <span>{{ row.tierCount || 0 }}</span>
          </template>
          <template #createTime="{ row }">
            <span>{{ formatDateTime(row.createTime) }}</span>
          </template>
          <template #updateTime="{ row }">
            <span>{{ formatDateTime(row.updateTime) }}</span>
          </template>
          <template #operation="{ row }">
            <el-tooltip
              effect="dark"
              content="编辑"
              placement="top-end"
              v-show="authorization('/home-admin/commission-rule/rule/edit')"
            >
              <el-button
                type="primary"
                icon="el-icon-edit"
                circle
                size="mini"
                @click="editRule(row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="编辑特定规则"
              placement="top-end"
              v-show="authorization('/home-admin/commission-rule/rule/tier-edit')"
            >
              <el-button
                type="success"
                icon="el-icon-setting"
                circle
                size="mini"
                style="margin-left: 5px"
                @click="editTier(row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top-end"
              v-show="authorization('/home-admin/commission-rule/rule/delete')"
            >
              <el-popconfirm
                title="确认删除吗？删除后将删除所有关联的特定规则"
                @confirm="deleteData(row)"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                  style="margin-left: 5px"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </BaseTable>
      </div>
    </div>
    <!-- 主规则新增/修改Dialog -->
    <RuleDialog
      ref="ruleDialogRef"
      :visible.sync="ruleDialogVisible"
      :rule-data="currentRule"
      @success="handleRuleSuccess"
    ></RuleDialog>
    <!-- 特定规则Dialog -->
    <TierDialog
      ref="tierDialogRef"
      :visible.sync="tierDialogVisible"
      :rule-id="currentRuleId"
      @success="handleTierSuccess"
    ></TierDialog>
  </div>
</template>

<script>
import { authorization } from "@/authorization/authorization";
import RuleDialog from "./components/RuleDialog.vue";
import TierDialog from "./components/TierDialog.vue";
import BaseTable from "@/components/BaseTable";
import moment from "moment";

export default {
  name: "CommissionRule",
  components: {
    RuleDialog,
    TierDialog,
    BaseTable,
  },
  data() {
    return {
      queryForm: {
        userIds: [],
      },
      tableData: [],
      total: 0,
      sizes: [10, 20, 50, 100],
      page: {
        pageNum: 1,
        pageSize: 20,
      },
      loading: false,
      ruleDialogVisible: false,
      tierDialogVisible: false,
      currentRule: null,
      currentRuleId: null,
      allUserList: [],
      columns: [
        {
          prop: "userAccount",
          label: "提成账号",
          showOverflowTooltip: true,
        },
        {
          prop: "userName",
          label: "提成账号姓名",
          showOverflowTooltip: true,
        },
        {
          prop: "isGlobal",
          label: "是否对所有人提成（不包含自身）",
          slot: "isGlobal",
        },
        {
          prop: "commissionRate",
          label: "提成比例",
          slot: "commissionRate",
        },
        {
          prop: "tierCount",
          label: "特定规则数量",
          width: "120",
          slot: "tierCount",
        },
        {
          prop: "remarks",
          label: "提成备注",
          showOverflowTooltip: true,
        },
        {
          prop: "createdByStr",
          label: "创建人",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "160",
          slot: "createTime",
        },
        {
          prop: "updatedByStr",
          label: "修改人",
        },
        {
          prop: "updateTime",
          label: "修改时间",
          width: "160",
          slot: "updateTime",
        },
      ],
    };
  },
  created() {
    this.getAllUserList();
  },
  mounted() {
    // 页面挂载后立即查询数据
    this.getData();
  },
  activated() {
    // 如果使用了 keep-alive，从缓存恢复时也会触发
    this.getData();
  },
  methods: {
    authorization,
    getAllUserList() {
      this.$store.dispatch("setAllUserList").then(() => {
        this.allUserList = this.$store.state.allUserList;
      });
    },
    getData() {
      const data = {
        page: this.page.pageNum,
        size: this.page.pageSize,
        userIds: this.queryForm.userIds,
      };
      this.loading = true;
      this.axios({
        url: "/v1/web/commission-rule/list",
        method: "post",
        data,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getData();
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNum = 1;
      this.getData();
    },
    editRule(data) {
      if (data) {
        this.currentRule = { ...data };
      } else {
        this.currentRule = null;
      }
      this.ruleDialogVisible = true;
    },
    editTier(row) {
      this.currentRuleId = row.id;
      this.tierDialogVisible = true;
    },
    handleRuleSuccess() {
      this.getData();
    },
    handleTierSuccess() {
      // 特定规则操作成功后，可以刷新列表或不做处理
    },
    reset() {
      this.$refs.queryFormRefs.resetFields();
      this.queryForm.userIds = [];
      this.getData();
    },
    deleteData(data) {
      this.axios({
        url: `/v1/web/commission-rule/delete/${data.id}`,
        method: "delete",
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("删除成功");
          this.getData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    formatDateTime(time) {
      if (!time) return "-";
      // 如果是时间戳（数字），转换为日期对象
      if (typeof time === "number") {
        return moment(time).format("YYYY-MM-DD HH:mm");
      }
      // 如果是字符串，直接格式化
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.container_form {
  width: 100%;
  overflow: hidden;
}

.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}

.table_add {
  margin-bottom: 10px;
}
</style>

